import ModalYouTube from './components/ModalYouTube.vue';
import {getVmModal} from './plugin'

const vmModal = getVmModal();

/**
 * YouTube モーダルをハッシュから開く
 *
 * 責務：
 * - ハッシュ文字列を解析して yt_id をパースする
 * - vmModal.open() で YouTube モーダルコンポーネントを表示
 * - モーダルを閉じた時点で history.replaceState() を実行
 */
export function openYtModalByHash(hash) {
    if (!hash) {
        // 初期表示時に本関数を実行していますが、location.hash がない場合は発火したくない
        return;
    }

    if (!vmModal) {
        console.warn('[openYtModalByHash] VmModal is not available');
        return;
    }

    // ハッシュパラメータを解析
    const params = Object.fromEntries(new URLSearchParams(hash));
    if (!params || !params.yt_id) {
        return;
    }

    async function openYtModalWithDelay() {
        try {
            const result = await vmModal.open({
                component: ModalYouTube,
                vars: {
                    yt_id: params.yt_id,
                    yt_start_time: params.yt_start_time || ''
                },
                type: 'popup',
            });

            if (result.action === 'close') {
                // モーダルを閉じた時に実行されるコールバック
                if (window.history && window.history.replaceState) {
                    const path = window.location.pathname + window.location.search;
                    const stateObj = {path: path, hash: hash, title: 'afterOpenYtModal'};
                    history.replaceState(stateObj, null, path);
                }
            }

        } catch (e) {
            console.error(e)
        }
    }

    // モーダルオープン遅延（ページ遷移アニメーション考慮）
    setTimeout(openYtModalWithDelay, 1000);
}

